export const SCAN_URLS_SIZE_LIMIT_ERROR_KEY: string = 'exceedMaxNumberOfUrls';
